<template>
  <details-header>
    <template v-slot:avatar>
      <v-img class="mx-auto" width="200" :src="$images.LOGO" />
    </template>
    <template v-slot:headerAppend>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="my-auto">
        <template v-if="is_complete">
          <strong>Finished</strong>
        </template>
        <template v-else-if="step == 0 || !is_active">
          <template v-if="survey.finishDate">
            <v-icon color="primary" class="mr-2">query_builder</v-icon>
            <span class="secondarytext--text">
              Complete by {{ survey.finishDate | longDate }}
            </span>
          </template>
        </template>
        <template v-else>
          <v-tooltip top v-if="survey.isBenchmark">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="success"
                small
                class="mr-2"
              >
                flash_on
              </v-icon>
            </template>
            <span class="pa-2">Benchmark Survey</span>
          </v-tooltip>
          <strong>Step</strong> {{ step }} of {{ survey.questions.length }}
        </template>
      </v-col>
      <v-col cols="12" sm="3" md="3" class="my-auto" v-if="showStatus">
        <v-progress-linear
          bottom
          :color="is_complete ? 'success' : step == 0 ? 'secondary' : 'primary'"
          rounded
          :value="progressValue"
          height="11"
        ></v-progress-linear>
      </v-col>
    </template>
    <survey-complete v-if="step > survey.questions.length"></survey-complete>
    <survey-step v-else></survey-step>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import DetailsHeader from "@/components/common/DetailsHeader";
import SurveyStep from "@/components/survey/SurveyStep";
import SurveyComplete from "@/components/survey/SurveyComplete";
export default {
  name: "SurveyContainer",
  components: {
    "details-header": DetailsHeader,
    "survey-step": SurveyStep,
    SurveyComplete
  },
  data: () => ({}),
  computed: {
    showStatus() {
      return (
        this.survey && this.survey.questions && this.is_active && this.step > 0
      );
    },
    progressValue() {
      if (this.survey.questions) {
        if (this.step == 0) {
          return 100;
        }
        if (
          this.survey.questions.length == 1 &&
          this.total_question_count > 0 &&
          !this.is_complete
        ) {
          return (
            (parseFloat(this.completed_question_count) /
              parseFloat(this.total_question_count)) *
            100
          );
        }
        return (
          (parseFloat(this.step - 1) /
            parseFloat(this.survey.questions.length)) *
          100
        );
      }
      return 0;
    },
    ...mapGetters({
      profile: "profile/profile",
      survey: "survey/survey",
      step: "survey/step",
      is_preview: "survey/is_preview",
      is_anonymous: "survey/is_anonymous",
      is_active: "profile/is_active",
      total_question_count: "survey/total_question_count",
      completed_question_count: "survey/completed_question_count",
      is_complete: "survey/is_complete"
    })
  }
};
</script>
